// import React, { useState, useEffect, useRef } from 'react';

// const ScormPlayer = ({ course }) => {
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);
//     // New state to ensure the API is ready before the iframe loads
//     const [isApiReady, setIsApiReady] = useState(false);
//     const iframeRef = useRef(null);

//     const scormDataRef = useRef({
//         "cmi.core.lesson_status": "not attempted",
//         "cmi.core.student_name": "User, Test",
//         "cmi.core.score.raw": "",
//         "cmi.suspend_data": ""
//     });

//     // **IMPORTANT**: This URL now points to our proxy, not the direct server.
//     // It's a relative path, so it uses the same origin as the React app.
//     // We construct the full path from the proxy base and the course-specific path.
//     const scormUrl = `http://localhost:8080/api/scorm/${course.storagePath}/${course.entryPoint}`;

//     // This is the hardcoded URL from your original code, adjusted for the proxy.
//     // Replace this with the dynamic `scormUrl` above for a real application.
//     const hardcodedProxyUrl = "/scorm-content/92a1cac9-faf5-4dc7-b972-071f6c6c4270/scormdriver/indexAPI.html";


//     useEffect(() => {
//         // --- SCORM 1.2 API Implementation ---
//         const API = {
//             LMSInitialize: (param) => {
//                 console.log("SCORM: LMSInitialize", param);
//                 scormDataRef.current["cmi.core.lesson_status"] = "incomplete";
//                 return "true";
//             },
//             LMSFinish: (param) => {
//                 console.log("SCORM: LMSFinish", param);
//                 console.log("Final SCORM Data:", scormDataRef.current);
//                 // In a real app, you would save data to a backend here.
//                 // For example: saveScormData(scormDataRef.current);
//                 return "true";
//             },
//             LMSGetValue: (key) => {
//                 const value = scormDataRef.current[key];
//                 console.log(`SCORM: LMSGetValue('${key}') -> '${value}'`);
//                 return value !== undefined ? value : "";
//             },
//             LMSSetValue: (key, value) => {
//                 console.log(`SCORM: LMSSetValue('${key}', '${value}')`);
//                 scormDataRef.current[key] = value;
//                 return "true";
//             },
//             LMSCommit: (param) => {
//                 console.log("SCORM: LMSCommit", param);
//                 // In a real app, you'd send data to the server here.
//                 return "true";
//             },
//             LMSGetLastError: () => "0",
//             LMSGetErrorString: (errorCode) => "No error",
//             LMSGetDiagnostic: (errorCode) => "No diagnostic information"
//         };

//         // Expose the API on the window object
//         window.API = API;
//         window.API_1484_11 = API; // For SCORM 2004 compatibility

//         // Signal that the API is ready
//         setIsApiReady(true);

//         // Cleanup function
//         return () => {
//             delete window.API;
//             delete window.API_1484_11;
//         };
//     }, []); // Empty dependency array ensures this runs only once.

//     const handleLoad = () => {
//         setIsLoading(false);
//         console.log("SCORM content iframe loaded.");
//     };

//     const handleError = (e) => {
//         console.error("Iframe load error:", e);
//         setError("Failed to load SCORM content. Check the browser console and network tab for details. Is the proxy configured correctly and the backend server running?");
//         setIsLoading(false);
//     };

//     return (
//         <div style={{ position: "relative", width: "100%", height: "100vh" }}>
//             {isLoading && <div style={{ padding: '20px' }}>Loading SCORM content...</div>}
//             {error && (
//                 <div style={{ color: 'red', padding: '20px', background: '#ffeeee' }}>
//                     Error: {error}
//                 </div>
//             )}

//             {/* **CRITICAL CHANGE**: Only render the iframe when the API is ready on the window. */}
//             {isApiReady && (
//                 <iframe
//                     ref={iframeRef}
//                     src={scormUrl} // Use the proxied URL here
//                     title="SCORM Course Player"
//                     style={{
//                         width: "100%",
//                         height: "100%",
//                         border: "none",
//                         visibility: isLoading || error ? 'hidden' : 'visible'
//                     }}
//                     sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-modals"
//                     allowFullScreen
//                     onLoad={handleLoad}
//                     onError={handleError}
//                 />
//             )}
//         </div>
//     );
// };

// export default ScormPlayer;







// src/components/ScormPlayer.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Box, CircularProgress, Alert, Typography, Button, AppBar, Toolbar } from '@mui/material';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const ScormPlayer = () => {
    const { courseId } = useParams();
    const [course, setCourse] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [scormUrl, setScormUrl] = useState(null);
    const iframeRef = useRef(null);
    
    const queryParams = new URLSearchParams(window.location.search);
    const studentId = queryParams.get('studentId');

    // Fetch course details
    useEffect(() => {
        const fetchCourse = async () => {
            try {
                console.log(`Fetching course ${courseId}`);
                const response = await axios.get(`${API_BASE_URL}/api/scorm/course/${courseId}`);
                console.log("Course response:", response.data);
                
                if (response.data?.success && response.data?.result?.length > 0) {
                    const courseData = response.data.result[0];
                    setCourse(courseData);
                    
                    // Build the SCORM content URL
                    const url = `${API_BASE_URL}/api/scorm/${courseData.storagePath}/${courseData.entryPoint}`;
                    console.log("SCORM URL:", url);
                    setScormUrl(url);
                } else {
                    setError('Course not found');
                }
            } catch (err) {
                console.error('Error fetching course:', err);
                setError('Failed to load course: ' + err.message);
            } finally {
                setLoading(false);
            }
        };

        if (courseId) {
            fetchCourse();
        }
    }, [courseId]);

    // Handle messages from iframe
    useEffect(() => {
        const handleMessage = async (event) => {
            // Check if message is from our iframe
            if (iframeRef.current && event.source === iframeRef.current.contentWindow) {
                const { type, data } = event.data || {};
                
                if (type === 'SCORM_DATA' && courseId && studentId) {
                    console.log("Received SCORM data:", data);
                    
                    try {
                        await axios.post(
                            `${API_BASE_URL}/api/scorm/scorm-progress/${courseId}`,
                            data,
                            { params: { studentId: studentId.toString() } }
                        );
                        
                        // Check if completed
                        const lessonStatus = data["cmi.core.lesson_status"];
                        if (lessonStatus === "completed" || lessonStatus === "passed") {
                            console.log("🎉 Course completed!");
                            localStorage.setItem(`course_completed_${courseId}`, 'true');
                            localStorage.setItem(`course_score_${courseId}`, data["cmi.core.score.raw"] || '100');
                            localStorage.setItem('scorm_pending_completion', 'true');
                        }
                    } catch (error) {
                        console.error('Failed to save SCORM data:', error);
                    }
                }
            }
        };
        
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [courseId, studentId]);

    const handleExit = () => {
        if (window.opener) {
            window.close();
        } else {
            window.location.href = '/';
        }
    };

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
                <CircularProgress size={50} />
                <Typography sx={{ mt: 2 }}>Loading course...</Typography>
            </Box>
        );
    }

    if (error) {
        return (
            <Box sx={{ p: 3 }}>
                <Alert severity="error" action={
                    <Button color="inherit" size="small" onClick={handleExit}>Close</Button>
                }>
                    {error}
                </Alert>
            </Box>
        );
    }

    if (!scormUrl) {
        return (
            <Box sx={{ p: 3 }}>
                <Alert severity="warning">Preparing course content...</Alert>
            </Box>
        );
    }

    return (
        <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1300, bgcolor: 'white', display: 'flex', flexDirection: 'column' }}>
            <AppBar position="static" color="primary">
                <Toolbar>
                    <Typography variant="h6" sx={{ flexGrow: 1 }}>
                        {course?.title || 'SCORM Course Player'}
                    </Typography>
                    <Button color="inherit" onClick={handleExit}>
                        Exit Course
                    </Button>
                </Toolbar>
            </AppBar>

            <iframe
                ref={iframeRef}
                src={scormUrl}
                title="SCORM Course Content"
                style={{
                    flex: 1,
                    width: '100%',
                    border: 'none'
                }}
                allow="fullscreen"
            />
        </Box>
    );
};

export default ScormPlayer;